module.exports = __webpack_public_path__ + "img/IS610269-4199.37a6aaec.png";